import SolutionCard from "../../reusables/SolutionCard";
import cctv from "../../../assets/images/solutions-icon/cctv.svg";

const CCTVSolution = () => {
  return (
    <SolutionCard
      icon={cctv}
      title="CCTV Installation & IT Security"
      subtitle="Surveilance systems and security solutions to protect your business and home"
      ctaLink="/solutions/cctv-security"
    />
  );
};
 
export default CCTVSolution;